"use client";

import * as React from "react";
import { cn } from "@/lib/utils";

export interface SeparatorProps {
  orientation?: "horizontal" | "vertical";
  variant?: "default" | "gradient";
  className?: string;
  children?: React.ReactNode;
}

export function Separator({
  orientation = "horizontal",
  variant = "default",
  className,
  children,
}: SeparatorProps) {
  const baseClasses =
    orientation === "horizontal" ? "h-px w-full my-2" : "w-px h-full mx-2";

  const variantClasses = {
    default: "bg-slate-200/70 dark:bg-zinc-800",
    gradient:
      "bg-gradient-to-r from-transparent via-slate-200/90 to-transparent dark:via-zinc-700",
  };

  if (children) {
    return (
      <div className={cn("relative my-4", className)}>
        <div className="absolute inset-0 flex items-center">
          <span
            role="separator"
            aria-orientation={orientation}
            className={cn("w-full", baseClasses, variantClasses[variant])}
          />
        </div>
        <div className="relative flex justify-center text-sm">{children}</div>
      </div>
    );
  }

  return (
    <div
      role="separator"
      aria-orientation={orientation}
      className={cn(baseClasses, variantClasses[variant], className)}
    />
  );
}
